export default "__VITE_ASSET__28f6b345__"